module.exports = __webpack_public_path__ + "dc8ef1bb1bcf7c4f1ba6d70c478de505.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg71.jpeg
// module id = 85
// module chunks = 0